var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", { staticClass: "estate" }, [
        _vm.data.items && _vm.data.items.length
          ? _c(
              "div",
              { staticClass: "row" },
              [
                _c(
                  "z-list",
                  _vm._l(_vm.data.items, function (item, index) {
                    return _c(
                      "z-list-item",
                      { key: index },
                      [
                        _c("z-link", {
                          attrs: {
                            href: item.file.link,
                            internal: "",
                            target: "_blank",
                          },
                          domProps: { innerHTML: _vm._s(item.name) },
                        }),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }